module.exports = __webpack_public_path__ + "static/img/Astronnaut.4f11a99.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Astronnaut.png
// module id = 2232
// module chunks = 61